const Loader = () => (
  <section className="loader-rjn">
    <span className="loader-72"> </span>
  </section>
);

export default Loader;
